import { url, header } from "../../apis/Index";
import axios from "axios";

export const getAcYears = () => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_AC_YEAR_INFO",
      fetchingAcYearLoaders: true,
    });
    axios
      .get(`${url}/Years`, {
        headers: header,
      })
      .then((acYears) => {
        dispatch({
          type: "GET_ACYEARS",
          acYears,
        });
        dispatch({
          type: "GETTING_AC_YEAR_INFO",
          fetchingAcYearLoaders: false,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GETTING_AC_YEAR_INFO",
          fetchingAcYearLoaders: false,
        });
        dispatch({
          type: "SET_AC_YEAR_MESSAGE",
          AcYearMessage: "Failed to get academic years",
        });
      });
  };
};

export const createAcYear = (newYear, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_AC_YEAR_INFO",
      loader: true,
    });
    axios
      .post(`${url}/Years`, newYear, {
        headers: header,
      })
      .then((acYear) => {
        dispatch({
          type: "CREATE_ACYEAR",
          acYear,
        });
        dispatch({
          type: "SENDING_AC_YEAR_INFO",
          loader: false,
        });
        closeFormAfterAdding();
      })
      .catch((error) => {
        dispatch({
          type: "SET_AC_YEAR_MESSAGE",
          AcYearMessage: "Failed to register academic year",
        });
        dispatch({
          type: "SENDING_AC_YEAR_INFO",
          loader: false,
        });
      });
  };
};

export const updateAcYear = (updatedAcYear, id, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_AC_YEAR_INFO",
      loader: true,
    });
    axios
      .put(`${url}/Years/${id}`, updatedAcYear, {
        headers: header,
      })
      .then((acYear) => {
        dispatch({
          type: "UPDATE_ACYEAR",
          acYear,
        });
        dispatch({
          type: "SENDING_AC_YEAR_INFO",
          loader: false,
        });
        closeFormAfterAdding();
      })
      .catch((error) => {
        dispatch({
          type: "SENDING_AC_YEAR_INFO",
          loader: false,
        });
        dispatch({
          type: "SET_AC_YEAR_MESSAGE",
          AcYearMessage: "Failed to update academic year",
        });
      });
  };
};

export const deleteAcYear = (id) => {
  return (dispatch) => {
    dispatch({
      type: "DELETING_AC_YEAR_INFO",
      deletingAcYear: {
        id: id,
        deleting: true,
      },
    });
    axios
      .delete(`${url}/Years/${id}`, {
        headers: header,
      })
      .then(() => {
        dispatch({
          type: "DELETE_ACYEAR",
          id,
        });
        dispatch({
          type: "DELETING_AC_YEAR_INFO",
          deletingAcYear: {
            id: null,
            deleting: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: "SET_AC_YEAR_MESSAGE",
          AcYearMessage: "Failed to delete academic year",
        });
        dispatch({
          type: "DELETING_AC_YEAR_INFO",
          deletingAcYear: {
            id: null,
            deleting: false,
          },
        });
      });
  };
};
